import { useMutation } from '@tanstack/react-query';
import { login, type LoginInput } from '@sentinel/auth-core';
import { useApi } from '../../lib/api';

export function useLogin() {
  const api = useApi();
  return useMutation({ mutationFn: (input: LoginInput) => login(api, input) });
}
